import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button, CircularProgress, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

import {
  CHECKING_BUTTON_SX,
  CHECKING_WITH_VENDOR_TEXT,
  VENDOR_CHECK_SPINNER_SIZE,
  VENDOR_CHECK_SPINNER_SX,
} from '../../../constants/marketplace';

interface IProps {
  hasBorder?: boolean;
  hasChevron?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

const rowSx: SxProps<Theme> = { display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' };

const toSxArray = (sx?: SxProps<Theme>) => (Array.isArray(sx) ? sx : [sx]);

const spinner = <CircularProgress size={VENDOR_CHECK_SPINNER_SIZE} thickness={5} sx={VENDOR_CHECK_SPINNER_SX} />;

export const VendorCheckNotice: React.FC<IProps> = ({
  hasBorder = false,
  hasChevron = false,
  fullWidth = false,
  sx,
}) => {
  if (hasBorder) {
    return (
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        disabled
        fullWidth={fullWidth}
        startIcon={spinner}
        endIcon={hasChevron ? <ChevronRightIcon /> : undefined}
        sx={[CHECKING_BUTTON_SX, ...toSxArray(sx)]}
      >
        {CHECKING_WITH_VENDOR_TEXT}
      </Button>
    );
  }

  return (
    <Box sx={[rowSx, ...toSxArray(sx)]}>
      {spinner}
      <Typography variant="body2" color="inherit">
        {CHECKING_WITH_VENDOR_TEXT}
      </Typography>
    </Box>
  );
};
